// import { motion } from "framer-motion";
// import {
//   Target,
//   ShieldCheck,
//   Zap,
//   TrendingUp,
//   Eye,
//   Briefcase,
//   Lightbulb,
// } from "lucide-react";

// const fadeInUp = {
//   initial: { opacity: 0, y: 20 },
//   animate: { opacity: 1, y: 0 },
//   transition: { duration: 0.5 },
// };

// export default function AboutPage() {
//   const stats = [
//     { number: "500+", label: "Projects Delivered" },
//     { number: "200+", label: "Happy Clients" },
//     { number: "50+", label: "Team Members" },
//     { number: "15+", label: "Years Experience" },
//   ];

//   const values = [
//     {
//       icon: <Target className="w-10 h-10 text-purple-600" />,
//       title: "Innovation",
//       description:
//         "We constantly push boundaries and embrace cutting-edge technologies to deliver solutions that set industry standards.",
//     },
//     {
//       icon: <ShieldCheck className="w-10 h-10 text-purple-600" />,
//       title: "Integrity",
//       description:
//         "Transparency and honesty guide every interaction. We build trust through ethical practices and open communication.",
//     },
//     {
//       icon: <Zap className="w-10 h-10 text-purple-600" />,
//       title: "Excellence",
//       description:
//         "We're committed to delivering exceptional quality in every project, exceeding expectations at every turn.",
//     },
//     {
//       icon: <TrendingUp className="w-10 h-10 text-purple-600" />,
//       title: "Growth",
//       description:
//         "We invest in our team's development and foster a culture of continuous learning and improvement.",
//     },
//   ];

//   return (
//     <div className="font-inter bg-white">
//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-r from-[#071c34] to-[#0f2a44] text-white py-24 overflow-hidden">
//         <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-40"></div>

//         <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7 }}
//             className="text-center"
//           >
//             <h1 className="text-5xl md:text-6xl font-bold mb-6">
//               About Infronex
//             </h1>
//             <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
//               Transforming businesses through innovative software solutions
//               since 2025. We're a team of passionate technologists dedicated to
//               building the future.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Our Story Section */}
//       <section className="py-20 bg-slate-50">
//         <div className="max-w-7xl mx-auto px-6 lg:px-8">
//           <div className="grid md:grid-cols-2 gap-12 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6 }}
//             >
//               <h2 className="text-4xl font-bold text-slate-900 mb-6">
//                 Our Story
//               </h2>
//               <p className="text-slate-600 leading-relaxed mb-4">
//                 Founded in 2025, Infronex began with a simple mission: to bridge
//                 the gap between complex technology and business success. What
//                 started as a small team of developers has grown into a
//                 full-service software company serving clients worldwide.
//               </p>
//               <p className="text-slate-600 leading-relaxed mb-4">
//                 Over the years, we've evolved alongside technology, constantly
//                 adapting and innovating to meet the changing needs of our
//                 clients. From web development to cloud solutions, we've built a
//                 reputation for delivering excellence.
//               </p>
//               <p className="text-slate-600 leading-relaxed">
//                 Today, we're proud to work with leading brands across
//                 industries, helping them navigate digital transformation and
//                 achieve their business goals through cutting-edge software
//                 solutions.
//               </p>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, x: 30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6 }}
//               className="relative"
//             >
//               <img
//                 src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop"
//                 alt="Team collaboration"
//                 className="rounded-2xl shadow-2xl w-full"
//               />
//               <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-purple-600 rounded-2xl -z-10"></div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       <section className="py-20 sm:py-32 bg-gradient-to-r from-slate-50 via-white to-slate-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
//             {/* Mission */}
//             <motion.div
//               initial="initial"
//               animate="animate"
//               variants={fadeInUp}
//               className="bg-white rounded-xl p-8 border-l-4 border-blue-600 shadow-sm hover:shadow-md transition"
//             >
//               <div className="flex items-center gap-3 mb-4">
//                 <Target className="text-blue-600" size={26} />
//                 <h3 className="text-2xl font-bold text-gray-900">
//                   Our Mission
//                 </h3>
//               </div>
//               <p className="text-lg text-gray-600 leading-relaxed">
//                 To deliver innovative, scalable, and sustainable digital
//                 solutions that empower businesses to thrive in the digital
//                 economy. We are committed to understanding our clients' unique
//                 challenges and providing tailored solutions that drive
//                 measurable results.
//               </p>
//             </motion.div>

//             {/* Vision */}
//             <motion.div
//               initial="initial"
//               animate="animate"
//               variants={{ ...fadeInUp, transition: { delay: 0.1 } }}
//               className="bg-white rounded-xl p-8 border-l-4 border-gray-500 shadow-sm hover:shadow-md transition"
//             >
//               <div className="flex items-center gap-3 mb-4">
//                 <Lightbulb className="text-gray-600" size={26} />
//                 <h3 className="text-2xl font-bold text-gray-900">Our Vision</h3>
//               </div>
//               <p className="text-lg text-gray-600 leading-relaxed">
//                 To be the most trusted and innovative technology partner for
//                 businesses seeking digital transformation. We aspire to create
//                 an ecosystem where innovation, creativity, and excellence
//                 converge to create exceptional value.
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Values Section */}
//       <section className="py-20 bg-slate-50">
//         <div className="max-w-7xl mx-auto px-6 lg:px-8">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//             className="text-center mb-16"
//           >
//             <h2 className="text-4xl font-bold text-slate-900 mb-4">
//               Our Core Values
//             </h2>
//             <p className="text-lg text-slate-600 max-w-2xl mx-auto">
//               The principles that guide everything we do and shape our company
//               culture
//             </p>
//           </motion.div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {values.map((value, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 whileHover={{ y: -8 }}
//                 className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-slate-100"
//               >
//                 <div className="mb-4">{value.icon}</div>

//                 <h4 className="text-xl font-bold text-slate-900 mb-3">
//                   {value.title}
//                 </h4>
//                 <p className="text-sm text-slate-600 leading-relaxed">
//                   {value.description}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-14 bg-gradient-to-br from-purple-600 to-purple-800 text-white">
//         <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//           >
//             <h2 className="text-3xl font-bold mb-4">Ready to Work Together?</h2>

//             <p className="text-base text-purple-100 mb-6 leading-relaxed">
//               Let’s discuss how we can transform your business with modern,
//               scalable software solutions.
//             </p>

//             <div className="flex flex-col sm:flex-row gap-3 justify-center">
//               <a
//                 href="/contact"
//                 className="
//             inline-flex items-center justify-center gap-2
//             px-6 py-3
//             bg-white text-purple-600
//             text-sm font-semibold
//             rounded-md
//             hover:bg-purple-50
//             transition-all duration-300
//             shadow-md hover:shadow-lg
//           "
//               >
//                 Get in Touch
//                 <svg
//                   className="w-4 h-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M17 8l4 4m0 0l-4 4m4-4H3"
//                   />
//                 </svg>
//               </a>

//               <a
//                 href="/portfolio"
//                 className="
//             inline-flex items-center justify-center
//             px-6 py-3
//             bg-purple-700
//             text-sm font-semibold
//             rounded-md
//             hover:bg-purple-800
//             transition-all duration-300
//             border border-purple-400
//           "
//               >
//                 View Our Work
//               </a>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// }

import { motion } from "framer-motion";
import {
  Target,
  ShieldCheck,
  TrendingUp,
  ArrowRight,
  Code2,
  Globe2,
  Cpu,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function AboutPage() {
  const values = [
    {
      icon: <Cpu size={24} />,
      title: "Innovation",
      description:
        "We leverage emerging technologies to build resilient systems that set new industry benchmarks.",
    },
    {
      icon: <ShieldCheck size={24} />,
      title: "Integrity",
      description:
        "Transparency is our foundation. We maintain absolute honesty in our technical delivery roadmaps.",
    },
    {
      icon: <Target size={24} />,
      title: "Excellence",
      description:
        "We deliver high-performance assets engineered for long-term scalability and precision.",
    },
    {
      icon: <TrendingUp size={24} />,
      title: "Growth",
      description:
        "Our culture is built on continuous evolution, ensuring our clients always lead the market.",
    },
  ];

  return (
    <div className="bg-white selection:bg-indigo-100">
      {/* ========== HERO SECTION (Existing) ========== */}
      <section className="relative bg-[#0f172a] py-32 overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.15]"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "24px 24px",
          }}
        ></div>
        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block text-indigo-400 text-[11px] font-bold tracking-[0.3em] uppercase mb-4">
              Our Identity
            </span>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-8 tracking-tight">
              Engineering the{" "}
              <span className="text-slate-400">Digital Vanguard.</span>
            </h1>
            <p className="text-lg text-white max-w-2xl mx-auto leading-relaxed font-light">
              Infronex is a global technology collective. We architect the
              software infrastructure that allows modern enterprises to operate
              at the speed of thought.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ========== STORY SECTION (Existing) ========== */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <motion.div {...fadeInUp}>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-[1px] bg-indigo-600"></div>
              <span className="text-xs font-bold text-indigo-600 uppercase tracking-widest">
                Perspective
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight">
              Architecting success through technical precision.
            </h2>
            <p className="text-slate-500 leading-relaxed text-[15px] mb-4">
              Infronex emerged from a core belief: technology should be an
              accelerator. We specialize in high-availability systems and
              complex digital transformations.
            </p>
          </motion.div>
          <motion.div
            className="relative"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop"
              className="rounded-2xl shadow-2xl grayscale-[30%]"
              alt="Story"
            />
          </motion.div>
        </div>
      </section>

      {/* ========== FOUNDATIONAL VALUES (Updated Card Style) ========== */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6 text-center mb-16">
          <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase mb-4 block">
            Our Principles
          </span>
          <h2 className="text-3xl font-bold text-slate-900">
            Built on Foundational Values.
          </h2>
        </div>

        <div className="max-w-6xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <motion.div
              key={index}
              {...fadeInUp}
              transition={{ delay: index * 0.1 }}
              className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl hover:border-indigo-500/30 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-slate-50 text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                {value.icon}
              </div>
              <h4 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                {value.title}
              </h4>
              <p className="text-[13px] text-slate-500 leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ========== CTA SECTION (Updated with Professional BG) ========== */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden">
        {/* Subtle Background Accent */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500 rounded-full blur-[120px]" />
        </div>

        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <motion.div {...fadeInUp}>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Partner with Infronex.
            </h2>
            <p className="text-slate-400 mb-10 max-w-xl mx-auto leading-relaxed">
              Let's discuss how our engineering capabilities can support your
              next phase of digital evolution.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="bg-white text-slate-900 px-8 py-3.5 rounded-xl text-sm font-bold hover:bg-indigo-50 transition-all flex items-center justify-center gap-2 shadow-lg"
              >
                Initiate Consultation <ArrowRight size={16} />
              </Link>
              {/* <Link
                to="/portfolio"
                className="border border-slate-700 text-slate-300 hover:text-white hover:border-slate-500 px-8 py-3.5 rounded-xl text-sm font-semibold transition-all"
              >
                Technical Portfolio
              </Link> */}
            </div>
            <p className="text-[11px] text-slate-500 mt-8 uppercase tracking-[0.2em]">
              Trusted by industry leaders worldwide
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}